import {
  Availability,
  ContractType,
  Office,
  Transportation,
} from '~/models/types'

export const transportationToJaText = (transportation: Transportation) => {
  switch (transportation) {
    case 'WALK':
      return '徒歩'
    case 'BUS':
      return 'バス'
    default:
      return transportation
  }
}

export const availabilityToJaText = (availability: Availability) => {
  switch (availability) {
    case 'AVAILABLE':
      return '空きあり'
    case 'AVAILABLE_SOON':
      return '空き予定'
    case 'UNAVAILABLE':
      return '空きなし'
    default:
      return availability
  }
}

export const contractTypeToJaText = (contractType: ContractType) => {
  switch (contractType) {
    case 'REGULAR_LEASE_CONTRAT':
      return '普通賃貸借契約'
    case 'FIXED_LEASE_CONTRAT':
      return '定期借家契約'
    case 'FACILITY_USE_CONTRACT':
      return '施設利用契約'
    default:
      return contractType
  }
}

export const officeStationsToText = (stations: Office['stations']) =>
  stations
    .reduce<Office['stations']>((acc, current) => {
      // 駅名の重複を避ける
      if (acc.every(({ name }) => name !== current.name)) acc.push(current)
      return acc
    }, [])
    .toSpliced(2)
    .map(
      ({ name, time, transportation }) =>
        `${name}駅${transportationToJaText(transportation)}${time}分`,
    )
    .join('、')

export const officeOtherAccessToText = (
  otherAccesses: Office['otherAccesses'],
) =>
  (otherAccesses ?? [])
    .map((otherAccess) => {
      return `（${otherAccess.accessType === 'BUS' ? 'バス' : 'その他'}）${otherAccess.description}`
    })
    .join('、')
